import React, { useEffect, useMemo, useState } from 'react';
import { Menu, Layout } from 'antd';
import { useLocation } from 'react-router-dom';
import _ from 'lodash';
import { findOpenKeys } from './menuActivity';

const { Sider } = Layout;

const Sidebar = ({
  beforeMenu,
  afterMenu,
  menu,
  children,
}) => {
  const location = useLocation();
  const [openKeys, setOpenKeys] = useState();

  const selectedKeys = useMemo(() => findOpenKeys(menu?.items, location.pathname), [location.pathname, menu]);

  useEffect(() => {
    setOpenKeys(_.uniq([...(menu.defaultOpenKeys || []), ...selectedKeys]));
  }, [location.pathname, menu, selectedKeys]);

  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    if (menu.items.find(item => item.key === latestOpenKey)) {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    } else {
      setOpenKeys(keys);
    }
  };

  return (
    <Sider
      theme="light"
      width={250}
      className="page-sidebar"
    >
      {children}
      {beforeMenu}
      {menu?.items?.length > 0 && (
      <Menu
        mode="inline"
        inlineIndent={16}
        selectedKeys={selectedKeys}
        openKeys={openKeys}
        onOpenChange={onOpenChange}
        {...(menu || {})}
      />
      )}
      {afterMenu}
    </Sider>
  );
};

export default Sidebar;
